import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useFeedbackRatingDistribution = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [feedbackDistributionData, setFeedbackDistributionData] = useState<FeedbackDistributionData[] | null>(null);

  const onFeedbackRatingDistributionError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while assigning driver.',
    );
  };

  const onFeedbackRatingDistributionSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<FeedbackDistributionData[]>) => {
    setFeedbackDistributionData(data);
  };

  const getFeedbackRatingDistribution = (data: { driverId: string; }) => {
    const url: HttpConfig = {
      url: `api/v1/dispatchers/${data?.driverId ?? ''}/feedbacks/counts`,
      method: 'get',
      // data: data,
    };
    request(url, onFeedbackRatingDistributionSuccess, setLoading, onFeedbackRatingDistributionError);
  };

  return { getFeedbackRatingDistribution, loading, feedbackDistributionData };
};

export default useFeedbackRatingDistribution;

interface FeedbackDistributionData {
  name: string;
  value: number;
  color: string;
  textColor: string;
}
